import { useNavigate, useParams } from 'react-router-dom';
import baja from '../../assets/img/unsuscribe.png'
import ActionCard from '../../components/SharedLayouts/ActionLayout/ActionCard'
import { useAppDispatch } from '../../redux/hooks'
import { postUnsubscribe } from '../../redux/slices/subscription/subscriptionThunk';
import { useState } from 'react';

const Unsuscribe = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { id } = useParams<{ id: string }>();

    const [loading, setLoading] = useState<boolean>(false);

    const handleUnsubscribe = async () => {
        setLoading(true);
        try {
            const result = await dispatch(postUnsubscribe(Number(id)))

            if (postUnsubscribe.fulfilled.match(result)) {
                if (result.payload.unsubscribe) {
                    navigate('/monitor/cancelar-suscripcion/exito')
                } else {
                    navigate('/monitor/cancelar-suscripcion/error')
                }
            } else if (postUnsubscribe.rejected.match(result)) {
                console.log('Error al dar de baja:', result.payload)
            }
        } catch (error) {
            console.log('Error inesperado:', error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <ActionCard
            image={baja}
            alt="darse de baja"
            title="¿Querés darte de baja de nuestro boletín?"
            description="Lamentamos que te vayas. Si confirmás tu baja, dejarás de recibir información sobre informes, actividades y actualizaciones del Monitor de Derechos."
            buttonLabel="Confirmar baja"
            buttonDisabled={loading}
            onClick={handleUnsubscribe}
        />
    )
}

export default Unsuscribe